<template>
  <div class="themeBody" :data-theme="themeMode">

    <div v-loading="loadingFlag" class="mainBoxForm" :class="{ 'mainBoxFormHigher': errorMsg }">

    <div class="userCenterFormBox">

      <div class="FormBoxTitle">{{ $t('h.userCenter.personalInformation') }}</div>

      <div>
        <el-avatar id="userLogo" :size="120" :src="getAvatar"></el-avatar>
      </div>
      <error-msg :errorMsg="errorMsg" :msgwidth="'300px'"/>
      <div class="inputTitle">{{ $t('h.common.username') }}</div>
      <el-input v-model="nick_name" :placeholder="$t('h.common.username')+'*'">
        <i class="el-icon-edit" slot="suffix" style="margin-top: 5px;font-size: 20px"></i>
      </el-input>

      <div class="inputTitle">{{ $t('h.common.email') }}</div>
      <el-input id="emailCode" v-model="email" :placeholder="$t('h.common.email')+'*'" disabled></el-input>

      <div style="margin: 10px 0 10px 0;">
        <el-button class="elBtn" type="primary" :disabled="isActiveSub" @click="changeUseInfo" :loading="!isGetUserInfo">
          {{$t('h.userCenter.modifyInformation')}}
        </el-button>
        <br>

        <el-button class="elBtn" type="primary" @click="goChangePassword" :loading="!isGetUserInfo">{{$t('h.userCenter.changePassword')}}
        </el-button>
        <br>
        <!--删除账号接口关闭 直接禁用-->
        <el-button class="elBtn" type="primary" @click="deleteAccount" disabled :loading="!isGetUserInfo">{{ $t('h.userCenter.cancelAccount') }}
        </el-button>
        <br>

        <el-button class="elBtn" type="primary" @click="logout" :loading="!isGetUserInfo">{{$t('h.userCenter.exitAccount')}}</el-button>
      </div>

      <area-select-footer v-show="$store.state.isInSlicer==false"/>

      <copyright style="margin-top: 20px"/>
    </div>

  </div>
  </div>
</template>

<script>
import {editUserInfo, userInfo} from "@/api/api";
import {OnClickGetLoginInfo} from "@/utils/studioWXMessage";
import {initializeLanguage} from "@/utils/utils";


export default {
  data() {
    return {
      nick_name: '',//用户名
      headimg_url: "",//头像图片url
      email: '',//用户邮箱
      old_nick_name: "",//初始用户名
      errorMsg: '',//错误提示信息
      isGetUserInfo:false,
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
    isActiveSub() {
      if (this.old_nick_name !== this.nick_name && this.old_nick_name !== "") {
        return false
      } else {
        return true
      }
    },
    getAvatar() {
      if (this.headimg_url) {
        return this.headimg_url
      } else {
        //如果图片获取失败 使用默认的logo图片
        return require("@/assets/logo.png");
      }
    }
  },
  created() {
    this.getUseInfo()
  },
  methods: {
    getUseInfo() {
      if (localStorage.getItem("token") === "") {
        //this.$notify.error({
        //   title: this.$t('h.common.tip'),
        //   message: this.$t('h.common.tipNeedLogin'),
        // })
        this.$router.push("/account/login")
      } else {
        console.log('有token,但还要检查token');
      }
      console.log(this.$store.state.userInfo)
      console.log('准备获取信息');
      this.loadingFlag = true
        userInfo().then((res) => {
          console.log(res)

          if (res.status === 0) {
            //this.$notify.success({
            //   title: this.$t('h.common.tip'),
            //   message: this.$t('h.common.tipGetUserInfoSuccess'),
            // })
            this.nick_name = res.data.nick_name
            this.email = res.data.email
            this.headimg_url = res.data.headimg_url
            this.old_nick_name = res.data.nick_name
            this.isGetUserInfo=true
            this.loadingFlag = false
          } else {
            this.loadingFlag = false
            this.isGetUserInfo=false
            console.warn("token可能过期了,token有误")
            this.$notify.error({
              title: this.$t('h.common.tip'),
              message: this.$t('h.common.tipGetUserInfoFail'),
            })
            this.logout()
            this.$router.push("/account/login")
          }
        }).catch((error) => {
          this.loadingFlag = false
          this.isGetUserInfo = false
          console.warn("请求超时了~")
          this.$notify.error({
            title: this.$t('h.common.tip'),
            message: this.$t('h.common.noUserInfoError'),
          })
          this.logout()
          this.$router.push("/account/login")
        }).finally(() => {
          this.loadingFlag = false
        })
    },
    calculateByteLength(str) {
      let byteLength = 0;
      for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i);
        if (charCode <= 0x007f) {
          byteLength += 1; // ASCII 字符或其他单字节字符
        } else if (charCode <= 0x07ff) {
          byteLength += 2; // 2 字节字符
        } else {
          byteLength += 3; // 大于 2 字节的字符（如中文）
        }
        // 如果超过了 30 字节，可以在这里添加逻辑处理
        if (byteLength > 30) {
          break;
        }
      }
      return byteLength;
    },

    changeUseInfo() {
      if (this.calculateByteLength(this.nick_name)>30){
          this.errorMsg=this.$t('h.userCenter.maxCharLimitTip')
          return
      }
      let formData = new FormData();
      formData.append('nick_name', this.nick_name);
      formData.append('email', this.email);
      editUserInfo(formData).then((res) => {
        //this.$notify.info({
        //   title: this.$t('h.common.tip'),
        //   message: this.$t('h.common.editUserInfoSuccess'),
        // })
        if (res.status === 0) {
          this.$store.commit("saveUserInfo", {})//清空旧的用户信息
          this.getUseInfo()
        }
      })
    },
    goChangePassword() {
      this.$router.push("/account/changePassword")
    },
    deleteAccount() {
      this.$router.push('/account/deleteUser')
    },
    logout() {

      //发送空的token给软件表示退出登录
      OnClickGetLoginInfo("")
      localStorage.clear();
      this.$store.commit('deleteUserVuex')

      // 初始化语言设置
      const initialLanguage = initializeLanguage();
      this.$store.commit('setLanguage', initialLanguage); // 设置 Vuex 中的语言
      console.warn("initialLanguage",initialLanguage)
      localStorage.setItem('locale', initialLanguage); // 设置 localStorage 中的语言

      this.$router.push("/account/login")
      //this.$notify.success({
      //   title: this.$t('h.common.tip'),
      //   message: this.$t('h.common.tipLoginOut'),
      // })
    },

  },

}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';


.mainBoxForm {
  height: 595px;
  @include background_color("background_color");
  @include font_color("text-color");
}

.mainBoxFormHigher{
  height: 660px;
}

>>> .userCenterFormBox {
  //display: flex;
  //flex-direction: column;
  width: 50%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  //border: 1px solid red;

  .FormBoxTitle {
    font-size: 30px;
    padding: 10px 0;
  }

  #userLogo{
    @include background_color("background_color");
  }

  .inputTitle {
    text-align: left;
    margin-top: 10px;
  }

  .el-input__inner  {
    height: 30px;
    border-radius: 0;
    border: 0;
    border-bottom: 1px solid #212B36; /* 初始状态的边框 */
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    transition: box-shadow 0.2s ease; /* 添加过渡效果 */

    @include background_color("background_color");
    @include border_color('elInputBorderColor')
  }
  .el-input__inner:not(#emailCode) {
    @include font_color('text-color');
  }


  .el-input__inner:focus {
    outline: none; /* 清除默认的聚焦样式 */
    @include border_color("elInputBorderFocusColor");
    /* 其他可能的聚焦样式调整 */
  }


  .elBtn {
    width: 100%;
    margin: 0;
    margin-top: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/account/userCenter.vue